<div class="items-container" data-cy="product-items-container">
  <div *ngFor="let item of items" class="flex flex-column item-container mb-4">
    <div class="flex align-items-start justify-content-between">
      <div data-cy="product-item-description-container">
        <p
          class="my-0 item-description p3 font-semibold"
          [innerHtml]="item.description"
          data-cy="product-item-description"
        ></p>
      </div>
      <div data-cy="product-item-quantity-container">
        <p
          class="p3 my-0 text-black-400 font-semibold"
          [innerHtml]="'Qty: ' + item.quantityToSubmit?.toString()"
          data-cy="product-item-quantity"
        ></p>
      </div>
    </div>
    <div *ngIf="item.warningMessage" class="-mt-2 -mb-4">
      <app-product-item-quantity-warning
        [title]="item.warningTitle"
        [messageHtml]="item.warningMessage"
      ></app-product-item-quantity-warning>
    </div>
  </div>
</div>
